export const ASSETS = {
  // Game interface assets
  interface: {
    logo: {
      path: 'assets/interface/logo.png',
      width: 300,
      height: 100
    },
    buttonBg: {
      path: 'assets/interface/button-bg.png',
      width: 200,
      height: 60
    },
    panelBg: {
      path: 'assets/interface/panel-bg.png',
      width: 400,
      height: 300
    }
  },
  
  // Character assets
  characters: {
    warriorIcon: {
      path: 'assets/characters/warrior-icon.png',
      width: 64,
      height: 64
    },
    mageIcon: {
      path: 'assets/characters/mage-icon.png',
      width: 64,
      height: 64
    },
    rangerIcon: {
      path: 'assets/characters/ranger-icon.png',
      width: 64,
      height: 64
    }
  },
  
  // Adventure zone backgrounds
  backgrounds: {
    forest: {
      path: 'assets/backgrounds/forest.png',
      width: 800,
      height: 400
    },
    caves: {
      path: 'assets/backgrounds/caves.png',
      width: 800,
      height: 400
    },
    mountains: {
      path: 'assets/backgrounds/mountains.png',
      width: 800,
      height: 400
    },
    castle: {
      path: 'assets/backgrounds/castle.png',
      width: 800,
      height: 400
    }
  },
  
  // Icons for resources and stats
  icons: {
    gold: {
      path: 'assets/icons/gold.png',
      width: 32,
      height: 32
    },
    experience: {
      path: 'assets/icons/experience.png',
      width: 32,
      height: 32
    },
    attack: {
      path: 'assets/icons/attack.png',
      width: 32,
      height: 32
    },
    defense: {
      path: 'assets/icons/defense.png',
      width: 32,
      height: 32
    }
  },
  
  // Sound effects
  sounds: {
    click: {
      path: 'assets/sounds/click.ogg',
      duration: 1
    },
    levelUp: {
      path: 'assets/sounds/level-up.ogg',
      duration: 2
    },
    battle: {
      path: 'assets/sounds/battle.ogg',
      duration: 3
    },
    purchase: {
      path: 'assets/sounds/purchase.ogg',
      duration: 1
    },
    victory: {
      path: 'assets/sounds/victory.ogg',
      duration: 2
    }
  }
};
